<script setup lang="ts">
import {isLexicalData, type RichTextValue} from '~/utils/lexical'
import Renderer from '~/components/lexical/renderer.vue'

const props = defineProps<{
  raw: RichTextValue
}>()
</script>

<template>
  <!-- Lexical JSON: use Vue renderer -->
  <Renderer v-if="isLexicalData(raw)" :data="raw" />

  <!-- Legacy HTML string: use v-html -->
  <div
    v-else-if="typeof raw === 'string'"
    class="prose prose-img:mx-auto prose-img:rounded-lg prose-img:border prose-img:border-gray-200"
    v-html="raw"
  />
</template>
